import { render, staticRenderFns } from "./StudentFeesReceiptDes.vue?vue&type=template&id=245ec628&scoped=true&"
import script from "./StudentFeesReceiptDes.vue?vue&type=script&lang=js&"
export * from "./StudentFeesReceiptDes.vue?vue&type=script&lang=js&"
import style0 from "./StudentFeesReceiptDes.vue?vue&type=style&index=0&id=245ec628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245ec628",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VIcon,VProgressCircular,VRadio,VRadioGroup,VSpacer,VToolbar,VToolbarTitle})
